import React from 'react';
import AudioIcon from '../autio-icon/AudioIcon';
import DocumentIcon from '../document-icon/DocumentIcon';
import QuizIcon from '../quiz-icon/QuizIcon';
import VideoIcon from '../video-icon/VideoIcon';


export default function LessonIcon({lesson}) {
    if (lesson.video_id !== null) {
        return <VideoIcon/>;
    }

    if (lesson.audio_id !== null) {
        return <AudioIcon/>;
    }

    if (lesson.quiz_id !== null) {
        return <QuizIcon/>;
    }

    if (lesson.document_id !== null) {
        return <DocumentIcon/>;
    }

    return <DocumentIcon/>;
}
